/**
 * Herkunfts-Kategorisierung für Aufgaben — visuelle Kennzeichnung, wo eine
 * Aufgabe erzeugt wurde (Scan-Eingang / E-Mail-Eingang / Datenübernahme /
 * unklar). Hilft gegen die "Aufgabenflut": auf einen Blick erkennbar, ob
 * eine Aufgabe aus einem Dokument, einer Mail, der Aktenübernahme oder aus
 * sonstigen Quellen (Agent-Automatik, manuell, Telefon, WhatsApp, RL-
 * Assistent, MCP, ...) stammt.
 *
 * Backend liefert (parallel umgesetzt) das Feld `herkunft_kategorie` — aber
 * NICHT garantiert bei jeder Aufgabe (viele Alt-/Randfälle bleiben
 * ungetaggt). Deshalb: Fallback über das bereits heute genutzte, lose
 * `quelle`-Feld (siehe AufgabenPage.jsx, Funktion istRauschen()).
 *
 * herkunftKategorie() garantiert, dass JEDE Aufgabe eine Kategorie/Farbe
 * bekommt — auch wenn weder herkunft_kategorie noch quelle gesetzt sind.
 */

export const HERKUNFT_FARBEN = {
  scan_eingang: {
    label: 'Scan-Eingang',
    farbe: 'blau',
    badge: 'bg-blue-100 text-blue-700 border-blue-200',
    dot: 'bg-blue-500',
  },
  email_eingang: {
    label: 'E-Mail-Eingang',
    farbe: 'gruen',
    badge: 'bg-green-100 text-green-700 border-green-200',
    dot: 'bg-green-500',
  },
  datenuebernahme: {
    label: 'Datenübernahme',
    farbe: 'gelb',
    badge: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    dot: 'bg-yellow-500',
  },
  unklar: {
    label: 'Unklarer Ursprung',
    farbe: 'rot',
    badge: 'bg-red-100 text-red-700 border-red-200',
    dot: 'bg-red-500',
  },
};

/**
 * Leitet die Herkunfts-Kategorie aus dem ALTEN `quelle`-Feld ab, falls
 * `herkunft_kategorie` (noch) nicht vom Backend gesetzt wurde (Alt-Aufgaben
 * vor der Migration, oder Insert-Stellen, die das Backend-Team bewusst
 * nicht einzeln angefasst hat). `quelle` hat sehr viele Werte (nicht
 * abschließend) — alles Unbekannte fällt auf "unklar".
 */
export function herkunftAusQuelle(quelle) {
  if (!quelle) return 'unklar';
  // posterfassung_*: historisch nicht unterscheidbar Scan/Übernahme
  if (quelle === 'posterfassung_zeo' || quelle === 'posterfassung_vorgang_match') return 'unklar';
  if (quelle === 'email') return 'email_eingang';
  if (
    quelle === 'aktenuebernahme' ||
    quelle === 'aktenuebernahme_zeo' ||
    quelle === 'butler21_import' ||
    quelle === 'butler21_migration'
  ) return 'datenuebernahme';
  // olymp_*, manuell, mcp, chat, whatsapp, gericht_nachforderung,
  // rl_assistent*, zeo_sip_fastagi, placetel_voicemail_email, u.v.m.
  return 'unklar';
}

/**
 * Ermittelt die Herkunfts-Kategorie einer Aufgabe. Garantiert IMMER einen
 * der 4 gültigen Schlüssel aus HERKUNFT_FARBEN zurückzugeben.
 */
export function herkunftKategorie(aufgabe) {
  const kat = aufgabe?.herkunft_kategorie || herkunftAusQuelle(aufgabe?.quelle);
  return HERKUNFT_FARBEN[kat] ? kat : 'unklar';
}
